let activeIndex = 0;
export function setActiveIndex(newActiveIndex) {
    activeIndex = newActiveIndex;
    return activeIndex;
}
export function getActiveIndex() {
    return activeIndex;
}
